import { ButtonPrimary, ButtonSize, IconLoader } from '@ui/src';
import OTPForm from '../../../components/settings/details-form/otp-form';
import useOTP from './hooks/use-otp';

import cn from '../styles.module.css';

const PspOtp = () => {
  const {
    isLoading,
    errorList,
    control,
    onSubmit,
    globalError,
    editIsLoading,
    isDirty,
    fields,
    setValue,
  } = useOTP();

  let content;

  if (isLoading) {
    content = (
      <div className={cn.settingsLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <>
        {!errorList && (
          <OTPForm
            control={control}
            onSubmit={onSubmit}
            fields={fields}
            setValue={setValue}
          >
            <>
              {globalError && (
                <div className={cn.saveGlobalError}>{globalError}</div>
              )}
              <ButtonPrimary
                text={editIsLoading ? 'Loading...' : 'Save'}
                onClick={onSubmit}
                bold
                size={ButtonSize.MEDIUM}
                disabled={editIsLoading || !isDirty}
                className={cn.saveDetailsButton}
              />
            </>
          </OTPForm>
        )}
        {errorList && (
          <div className={cn.loadingError}>
            <div className={cn.loadingErrorTitle}>Unable to load data</div>
            <div className={cn.loadingErrorText}>{errorList}</div>
          </div>
        )}
      </>
    );
  }

  return content;
};

export default PspOtp;
